<template>
  <div style="background-color:#181C2D0D;">
    <div class="container ">
      <div class="pd">
        <div class="header">
          <h3 >
            What You will learn
          </h3>
        </div>
        <div class="grid">
          <div>
            <h4 class="course-outline-h">
              <span >Course Outline</span>
            </h4>
            <div><span class="text-bold">Instructor:</span><span class="inst-name"> Sanjoy K. Paul</span></div>
            <div style="padding-bottom: 1em;"><span class="text-bold">Lead Application Developer</span></div>
            <p class="course-outline">
              <span class="text-bold topics">1. Improving the way we think about layout</span>
              <ul class="list-padding list-items">
               <li> Block Formatting Contexts (BFC)</li>
                <li>Understanding what a BFC is, why it works, and how to create one is useful and can help you  understand how layouts work in CSS.</li>

              </ul>
<span v-if="readMore"></span>
    <span v-else>...</span>
  </p>

  <p class="course-outline" v-show="readMore">
    <span class="text-bold topics">2. Stacking Contexts</span>


<ul class="list-padding list-items"> <li>What is Stacking</li>
    <li> How to use Stacking in HTML/CSS</li>
    <li> Where to use Stacking in HTML/CSS</li>
    <li> Tags, Attributes & Elements	</li>
    <li> Pixels, Percentages, Points & Ems!</li>
    <li> The Box Model</li>
</ul>

<span class="text-bold topics">3. Advanced Selectors</span>
<ul class="list-padding list-items">
  <li>What are Advanced Selectors</li>
  <li>How to use it in HTML/CSS</li>
  <li>Internal Styles</li>
  <li>External Styles</li>
  <li>Inline Styles</li>
</ul>

<span class="text-bold topics">4. Neat things you didn't know you could do with CSS</span>
<ul class="list-padding list-items">
  <li>Creating reusable classes</li>
  <li>The Box Model</li>
  <li>CSS Positioning</li>
  <li>Tips, tricks of CSS</li>
  <li>Content overflowing</li>
</ul>

<span class="text-bold topics">5. Media Blocks</span>
<ul class="list-padding list-items"><li>What is a media block </li>
  <li>User cases and how we use it</li>
  <li>Inheritance of Styles</li>
</ul>

<span class="text-bold topics">6  CSS features like Flexbox, Grid  and Web Components</span>
	<ul class="list-padding list-items">
    <li>Overview and discussion about upcoming features</li>
  </ul>

<span class="text-bold topics">7. Injecting Content using CSS</span>
<ul class="list-padding list-items">
   <li>:before and :after</li>
   <li> How to use advance features with property like :after and :before</li>
   <li> Mobile first development</li>
</ul>



<span class="text-bold topics">8. CSS Animations</span>
<ul class="list-padding list-items">
  <li>What is animation in CSS</li>
  <li>Where do we use animations</li>
</ul>

<span class="text-bold topics">9. Structuring your CSS </span>
<ul class="list-padding list-items">
  <li> Guide-lines to write CSS.</li>
</ul>

<span class="text-bold topics">10. API Integration</span>
<ul class="list-padding list-items">
  <li>What is Web API</li>
  <li>How to integrate Web API</li>
</ul>

<span class="text-bold topics">11. Using LESS </span>
<ul class="list-padding list-items">
  <li>Overview on LESS framework</li>
  <li>Benefits of LESS</li>
</ul>

<span class="text-bold topics">12. Project </span>
<ul class="list-padding list-items">
  <li>1-2 projects throughout the course</li>
  <li>One landing page with CSS</li>
  <li>One dashboard with CSS</li>
  <li>Debugging CSS</li>
  <li>How to properly use DevTools of Firefox or Chrome</li>
  <li>Resources </li>
</ul>


  </p>
 <a class="text-bold read-more" @click="readMore =! readMore">
    <span v-if="readMore">Read Less</span>
    <span v-else>Read More</span>
  </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
       readMore: false
    }
  }
};
</script>

<style scoped>
.text-bold{
  font-weight: 600;
}
.topics{
  font-size: 20px;
}
.list-padding{
  padding-left: 1.5em;
}
.pd{
  padding : 100px 0;
}
.list-items{
  list-style-type: circle;
}
.header h3 {
text-transform: uppercase;
  font-family: "Spartan";
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 7.2px;
  line-height: 24px;
color: black;
}

.course-outline{
  font-size: 18px;
}
.inst-name{
  font-size: 18px;
}
.course-outline-h{
  text-transform: uppercase;
  font-family: "Spartan";
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 6.4px;
  line-height: 24px;
 color:#FFC600;
 background:#072AC8;
 max-width:630px ;
 padding: 15px 35px;
  margin: 25px 0;
}
.read-more{
color: #072ac8;
cursor: pointer;
}
@media only screen and (max-width: 600px) {
  .container{
    padding-left: 0;
    padding-right: 0;
  }
  .pd{
    padding: 50px 20px !important;
  }
}
@media only screen and (min-width: 1300px) {
  .container{
  max-width: 1350px !important;
}
.header h3{
  font-size: 24px;
}
.course-outline-h{
  text-transform: uppercase;
  font-family: "Spartan";
  font-size: 24px;
  font-weight: 800;
  letter-spacing: 7.2px;
  line-height: 24px;
 color:#FFC600;
 background:#072AC8;
 max-width:630px ;
 padding: 15px 35px;
  margin: 25px 0;
}
.grid li{
   font-family: "Poppins";
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: #304F64;
  margin: 15px 0;
}
.grid li span{
   font-family: "Poppins";
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: #304F64;
  margin: 15px 0;
}
}
.pd {
  padding: 100px 25px;
}
</style>
